export default {
      id: "ic_coupon_order-usage",
      viewBox: "0 0 35 24",
      url: "/" + "images/icons.3.109.2.svg#ic_coupon_order-usage",
      toString: function () {
        return this.url;
      }
    }